import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pop-up-header',
  templateUrl: './pop-up-header.component.html',
  styleUrls: ['./pop-up-header.component.scss']
})
export class PopUpHeaderComponent implements OnInit {
  @Input() headerName: string;
  @Input() subHeaderName: string;
  @Input() showSuccessIcon: string;
  @Input() textTransformNone: boolean;
  @Input() showCloseBtn = true;
  @Output() close = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  closePopup(): void {
    this.close.emit();
  }

}
